<template>
  <div class="box-white">
    <div class="d-flex justify-content-between fw-bold">
      {{ $t('speed') }} <span>%{{ maxSpeedLimit }}</span>
    </div>
    <input type="range" min="0" max="100" step="5" v-model.number="maxSpeedLimit" class="speed-slider" />
  </div>
  <div class="minimal-wrapper">
    <div class="d-flex position-absolute w-100 justify-content-between top-0">
      <span class="box-white fw-bold">% {{ Math.floor(this.rawMotorValues.left / 100 * this.maxSpeedLimit) }}</span>
      <span class="box-white fw-bold">% {{ Math.floor(this.rawMotorValues.right / 100 * this.maxSpeedLimit) }}</span>
    </div>

    <div class="joy-base" ref="joyBase" @mousedown="init" @touchstart.prevent="init">
      <div class="axis x"></div>
      <div class="axis y"></div>

      <div class="joy-handle" :style="{ transform: `translate(${joyPos.x}px, ${joyPos.y}px)` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlexibleJoystick',
  data() {
    return {
      isMoving: false,
      joyPos: { x: 0, y: 0 },
      rawMotorValues: { left: 0, right: 0 },
      lastSendValues: { left: 0, right: 0 },
      maxSpeedLimit: 50,
      currentRadius: 0,
      joystickControl: null,
    }
  },
  computed: {},
  mounted() {
    this.updateRadius();
    window.addEventListener('resize', this.updateRadius);
    window.addEventListener('mousemove', this.exec);
    window.addEventListener('mouseup', this.reset);
    window.addEventListener('touchmove', this.exec, { passive: false });
    window.addEventListener('touchend', this.reset);

    let lastSeen = new Date().getTime()
    this.joystickControl = setInterval(() => {
      const currentTime = new Date().getTime()
      const diffSpeed = this.lastSendValues.left != this.rawMotorValues.left || this.lastSendValues.right != this.rawMotorValues.right
      const diffSpeedZero = this.lastSendValues.left != 0 || this.lastSendValues.right != 0
      if (diffSpeed || (diffSpeedZero && currentTime - lastSeen > 1000)) {
        if (this.lastSendValues.left != this.rawMotorValues.left) this.lastSendValues.left = this.rawMotorValues.left
        if (this.lastSendValues.right != this.rawMotorValues.right) this.lastSendValues.right = this.rawMotorValues.right
        this.$axios.post({ port: 3020, uri: '/pwm', valueData: { motor: 'left', value: (this.lastSendValues.left / 100 * this.maxSpeedLimit) }, slice: true })
        this.$axios.post({ port: 3020, uri: '/pwm', valueData: { motor: 'right', value: (this.lastSendValues.right / 100 * this.maxSpeedLimit) }, slice: true })
        lastSeen = currentTime
        console.log(this.lastSendValues)
      }
    }, 250);

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateRadius);
    if (this.joystickControl) {
      clearInterval(this.joystickControl);
    }
  },
  methods: {
    updateRadius() {
      if (this.$refs.joyBase) {
        this.currentRadius = this.$refs.joyBase.offsetWidth / 2;
      }
    },
    init() { this.isMoving = true; },
    reset() {
      this.isMoving = false;
      this.joyPos = { x: 0, y: 0 };
      this.rawMotorValues = { left: 0, right: 0 };
    },
    exec(e) {
      if (!this.isMoving) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const rect = this.$refs.joyBase.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      let dx = clientX - cx;
      let dy = clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist > this.currentRadius) {
        dx *= this.currentRadius / dist;
        dy *= this.currentRadius / dist;
      }

      this.joyPos = { x: dx, y: dy };

      const power = (-dy / this.currentRadius) * 100;
      const steer = (dx / this.currentRadius) * 50;

      // Ham değerleri hesapla ve 5'e yuvarla
      let rawL = Math.round((power + steer) / 5) * 5;
      let rawR = Math.round((power - steer) / 5) * 5;

      // Sınırları koru
      this.rawMotorValues.left = Math.min(100, Math.max(-100, rawL));
      this.rawMotorValues.right = Math.min(100, Math.max(-100, rawR));
    },
  }
}
</script>

<style scoped>
span {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Önceki stillerle aynı, sadece okunabilirliği koruduk */
.minimal-wrapper {
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  font-family: monospace;
}

.speed-slider {
  width: 100%;
  cursor: pointer;
  accent-color: #333;
}

.joy-base {
  width: 100%;
  max-width: 300px;
  aspect-ratio: 1 / 1;
  border: 1px solid #ddd;
  border-radius: 50%;
  position: relative;
  background: #fafafa;
  touch-action: none;
}

.axis {
  position: absolute;
  background: #eee;
}

.axis.x {
  width: 100%;
  height: 1px;
  top: 50%;
  left: 0;
}

.axis.y {
  width: 1px;
  height: 100%;
  left: 50%;
  top: 0;
}

.joy-handle {
  width: 12%;
  aspect-ratio: 1 / 1;
  background: #fff;
  border: 2px solid #333;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -6%;
  margin-top: -6%;
  pointer-events: none;
  z-index: 2;
}
</style>